import { Routes, Route } from 'react-router-dom'
import ApplicationEdit from '@pages/applications/edit'
import ApplicationNew from '@pages/applications/new'
import ApplicationPreview from '@pages/applications/preview'
import ApplicationsList from '@pages/applications/list'
import ExternalAuthentication from '@pages/external-authentication'
import Layout from '@components/layout/layout'
import Login from '@pages/login/login'
import NotFound from '@pages/not-found/not-found'
import OperationPreview from '@pages/operations/preview'
import OperationsList from '@pages/operations/list'
import PrivateRoute from '@components/routes/private-route'
import RequestPreview from '@pages/requests/preview'
import RequestsList from '@pages/requests/list'
import SagaTransactionPreview from '@pages/saga-transactions/preview'
import SagaTransactionsList from '@pages/saga-transactions/list'
import TokenNew from '@pages/tokens/new'
import TokenPreview from '@pages/tokens/preview'
import TokensList from '@pages/tokens/list'
import RestrictPrivateRoute from './restrict-private-route'

function AppRoutes() {
  return (
    <Routes>
      <Route path='login' element={<Login />} />
      <Route path='authentication/new' element={<ExternalAuthentication />} />

      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>

          <Route element={<RestrictPrivateRoute />}>
            <Route path='tokens/new' element={<TokenNew />} />
            <Route path='applications/new' element={<ApplicationNew />} />
            <Route path='applications/:applicationId/edit' element={<ApplicationEdit />} />
          </Route>

          <Route index element={<ApplicationsList />} />

          <Route path='applications'>
            <Route index element={<ApplicationsList />} />
            <Route path=':applicationId' element={<ApplicationPreview />} />
          </Route>

          <Route path='tokens'>
            <Route index element={<TokensList />} />
            <Route path=':tokenId' element={<TokenPreview />} />
          </Route>

          <Route path='operations'>
            <Route index element={<OperationsList />} />
            <Route path=':operationId' element={<OperationPreview />} />
          </Route>

          <Route path='transactions'>
            <Route index element={<SagaTransactionsList />} />
            <Route path=':sagaTransactionId' element={<SagaTransactionPreview />} />
          </Route>

          <Route path='requests'>
            <Route index element={<RequestsList />} />
            <Route path=':requestId' element={<RequestPreview />} />
          </Route>
        </Route>
      </Route>

      <Route path='*' element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
